import React from 'react';

import { SVGPropsType } from 'src/types';

const CopyLink = (props: SVGPropsType) => {
    const { fill, stroke, onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <g clipPath="url(#clip0_33922_19685)">
                <circle cx="16" cy="16" r="16" fill={fill} />
                <path
                    d="M23.4148 8.47273C22.5032 7.57273 21.2602 7.08182 19.9344 7C18.6085 7 17.3655 7.49091 16.4539 8.39091L14.9623 9.86364C14.6309 10.1909 14.6309 10.6818 14.9623 11.0091C15.2938 11.3364 15.791 11.3364 16.1225 11.0091L17.5312 9.61818C18.1941 9.04545 19.0228 8.63636 19.9344 8.71818C20.8459 8.71818 21.5917 9.04545 22.2546 9.7C22.8347 10.2727 23.1662 11.0909 23.1662 11.9091C23.1662 12.8091 22.8347 13.6273 22.2546 14.2L19.7686 16.6545C19.4371 16.9818 19.0228 17.2273 18.6085 17.3909C18.1941 17.6364 17.6969 17.6364 17.1997 17.6364C16.7025 17.6364 16.2882 17.4727 15.8739 17.2273C15.4595 16.9818 15.1281 16.6545 14.7966 16.3273C14.548 16 13.9679 15.9182 13.6365 16.1636C13.305 16.4091 13.2221 16.9818 13.4707 17.3091C13.8851 17.8818 14.4651 18.3727 15.0452 18.7C15.7081 19.0273 16.3711 19.2727 17.034 19.2727C17.1169 19.2727 17.2826 19.2727 17.3655 19.2727C17.9455 19.2727 18.5256 19.1909 19.1057 18.9455C19.7686 18.7 20.3487 18.2909 20.8459 17.8L23.3319 15.3455C24.2434 14.4455 24.7406 13.2182 24.7406 11.9091C24.8235 10.6 24.3263 9.37273 23.4148 8.47273Z"
                    fill={stroke}
                />
                <path
                    d="M15.3771 20.9909L13.9683 22.3818C13.3054 22.9545 12.5596 23.2818 11.6481 23.2818C10.7365 23.2818 9.99072 22.9546 9.32779 22.3C8.74772 21.7273 8.41625 20.9091 8.41625 20.0909C8.41625 19.2727 8.74772 18.3727 9.32779 17.8L11.8138 15.3455C12.1453 15.0182 12.5596 14.7727 12.9739 14.6091C13.3883 14.4455 13.8855 14.3636 14.3827 14.3636C14.8799 14.3636 15.2942 14.5273 15.7086 14.7727C16.1229 15.0182 16.4544 15.3455 16.7858 15.6727C17.0344 16 17.6145 16.0818 17.946 15.8364C18.2774 15.5909 18.3603 15.0182 18.1117 14.6909C17.6974 14.1182 17.1173 13.6273 16.5372 13.3C15.8743 12.9727 15.2113 12.7273 14.5484 12.7273C13.8026 12.6455 13.0568 12.8091 12.3939 13.0545C11.7309 13.3 11.1509 13.6273 10.6537 14.2L8.16765 16.6546C7.17324 17.5546 6.67604 18.7818 6.75891 20.0909C6.75891 21.4 7.25611 22.6273 8.25052 23.5273C9.16205 24.4273 10.4051 24.9182 11.7309 25C11.7309 25 11.7309 25 11.8138 25C13.1397 25 14.2998 24.5091 15.2942 23.6091L16.703 22.2182C17.0344 21.8909 17.0344 21.4 16.703 21.0727C16.2886 20.6636 15.7086 20.6636 15.3771 20.9909Z"
                    fill={stroke}
                />
            </g>
            <defs>
                <clipPath id="clip0_33922_19685">
                    <rect width="32" height="32" fill={stroke} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CopyLink;
